<div class="filter-section">
  <mat-form-field class="table-text-filter">
    <mat-label>Filter</mat-label>
    <input
      [formControl]="filterInputControl"
      aria-label="filter"
      autocomplete="off"
      matInput
      type="text"
    />
    <button
      (click)="filterInputControl.setValue(''); $event.stopPropagation()"
      *ngIf="filterInputControl.value"
      class="tertiary-button"
      mat-icon-button
      matSuffix
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>
